import { jsx as _jsx } from "react/jsx-runtime";
import { columnSelectContext } from './columnSelectContext';
import { useColumnSelectorState } from '../state/useColumnSelectorState';
import { useColumnSelectorPanelState } from '../state/useColumnSelectorPanelState';
/**
 * A provider that provides context for column selection
 *
 * > You probably use this externally, but using the ColumnSelect component
 * > is probably going to be a lot easier.
 */
export const ColumnSelectProvider = ({ allColumnList, defaultColumnKeyList, parentStorageKey, children, }) => {
    const { isOpen, toggle, setOpen } = useColumnSelectorPanelState();
    const { selectedColumnList, selectedKeyList, setSelectedKeyList } = useColumnSelectorState({
        allColumnList,
        defaultColumnKeyList,
        parentStorageKey,
    });
    const value = {
        isOpen,
        setOpen,
        selectedKeyList,
        setSelectedKeyList,
        selectedColumnList,
        allColumnList,
        toggle,
        parentStorageKey,
        defaultColumnKeyList,
    };
    return (_jsx(columnSelectContext.Provider, Object.assign({ value: value }, { children: children })));
};
